import Block from '../block'

export default class ShoppingcartProduct extends Block {
	static title = 'shoppingcart-product'

	init() {
		this.input = this.getElement('number__input')
		this.plus = this.getElement('number__button[data-plus]')
		this.min = this.getElement('number__button[data-min]')

		if (this.plus) {
			this.plus.addEventListener('click', () => {
				this.input.value = parseInt(this.input.value, 10) + 1
				this.input.form.submit()
			})
		}

		if (this.min) {
			this.min.addEventListener('click', () => {
				this.input.value = Math.max(parseInt(this.input.value, 10) - 1, 0)
				this.input.form.submit()
			})
		}
	}
}
